import React from 'react';

const ReframeContext = React.createContext();

export default ReframeContext